import { render, staticRenderFns } from "./checkout-overview.vue?vue&type=template&id=94bc4be0"
import script from "./checkout-overview.vue?vue&type=script&lang=ts"
export * from "./checkout-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports